import { StyleRulesCallback, Theme } from '@material-ui/core';
import { BaseLinkClassKey } from '../types';

export const czLinkButtonStyles: StyleRulesCallback<Theme, Record<string, unknown>, BaseLinkClassKey> = (theme: Theme) => ({
  link: { color: theme.palette.primary.main, textDecoration: 'underline', paddingBottom: theme.spacing(1) },
  text: {
    color: theme.palette.primary.main,
    fontSize: '15px',
    lineHeight: '27px',
  },
});